<template>
  <div id="catalogoArea" class="contenedor">
    <Sidebar></Sidebar>
    <loader :show="show" />
    <v-container
      fluid
      class="base text-center ma-0 px-0 pt-6 pb-0"
      v-if="catalogo"
    >
      <v-row no-gutters class="titulo catalogoTitle">Catálogo de Área</v-row>

      <v-row class="catalogo catalogoList">
        <v-col cols="12" sm="8" class="py-3"
          >¿La estructura organizacional será por?</v-col
        >
        <v-col cols="12" sm="4" class="py-3 selectGris">
          <select name="estructura" id="estructura" v-model="estructura">
            <option disabled value="0">Selecciona estructura</option>
            <option
              v-for="carga in structure"
              :key="carga.id"
              v-bind:value="carga.id"
            >
              {{ carga.nombre }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-3" v-if="estructura == 2"
          >Empresa Pagadora</v-col
        >
        <v-col cols="12" sm="4" class="py-3 selectGris" v-if="estructura == 2">
          <select name="pagadora" id="pagadora" v-model="enterprise">
            <option disabled value="0">Selecciona</option>
            <option
              v-for="enterprise in enterprises"
              :key="enterprise.id"
              v-bind:value="enterprise.id"
            >
              {{ enterprise.razonSocial }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-3">¿El tipo de carga?</v-col>
        <v-col cols="12" sm="4" class="py-3 selectGris">
          <select name="location" id="location" v-model="carga">
            <option disabled value="0">Selecciona carga</option>
            <option
              v-for="carga in cargas"
              :key="carga.id"
              v-bind:value="carga.id"
            >
              {{ carga.nombre }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-1" v-if="carga == 2">
          <p style="font-size: 18px">
            <i style="color: #0f6c21" class="fas fa-file-excel"></i>
            <a href="#" @click="descargaExcel()">&nbsp;&nbsp;Descargar</a>
            plantilla de excel para llenar.
          </p>
        </v-col>

        <v-col cols="12" sm="12" class="uploadfile py-2" v-if="carga == 2">
          Subir archivo de Excel con la lista de áreas a registrar.
          <input
            type="file"
            id="archivo"
            lang="es"
            ref="fileUploadPerfilEdit"
            @click="resetFile"
            @change="previewFiles($event)"
          />
        </v-col>
        <v-col cols="12" sm="12" class="mt-3 pa-0" align-self="end">
          <button class="boton" @click="validacion()">Siguiente</button>
          <router-link to="/areasList">
            <button class="boton">Regresar</button>
          </router-link>
        </v-col>
      </v-row>
    </v-container>

    <v-container
      fluid
      class="base text-center ma-0 px-0 pt-6 pb-0"
      v-if="lista"
    >
      <v-row no-gutters class="titulo catalogoTitle">Alta de Área</v-row>
      <v-row class="catalogo catalogoList">
        <v-col cols="12" sm="8" class="py-2">Empresa Pagadora</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select name="pagadora" id="pagadora" v-model="enterprise">
            <option disabled value="0">Selecciona</option>
            <option
              v-for="enterprise in enterprises"
              :key="enterprise.id"
              v-bind:value="enterprise.id"
            >
              {{ enterprise.razonSocial }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2">
          <label for="nomarea">Nombre de área</label>
        </v-col>
        <v-col cols="12" sm="4" class="py-2 com">
          <input
            type="text"
            id="nomarea"
            name="nomarea"
            class="px-3"
            style="width: 90% !important"
            v-model="area"
          />
        </v-col>
        <v-col cols="12" sm="8" class="py-2">
          <label for="corto">Nombre corto</label>
        </v-col>
        <v-col cols="12" sm="4" class="pa-2 com">
          <input
            type="text"
            id="corto"
            name="corto"
            class="px-3"
            style="width: 90% !important"
            v-model="nombreCorto"
          />
        </v-col>
        <v-col cols="12" sm="8" class="py-2">Nivel de áreas</v-col>
        <v-col cols="8" sm="4" class="py-2 selectGris">
          <select style="width: 80%" name="level" id="level" v-model="level">
            <option disabled value="0">Seleccione nivel</option>
            <template v-for="index in 99">
              <option :key="index" :value="index">{{ index }}</option>
            </template>
          </select>
          <a @click="auxNivel = true"
            ><i style="color: #f7b30b" class="ml-2 fas fa-question-circle"></i
          ></a>
        </v-col>
        <v-col>
          <div class="form-group text-center terminos mt-4">
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="regresar()"
            >
              Regresar
            </button>
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="guardarArea()"
            >
              Guardar
            </button>
          </div>
        </v-col>
      </v-row>
      <v-col></v-col>
    </v-container>

    <!--Error-->
    <v-dialog v-model="error" width="380">
      <v-card>
        <v-card-title class="red white--text">
          <span class="headline">{{ titulo }}</span>
        </v-card-title>
        <v-card-text>
          <h3 class="text-md-center text-sm-center text-lg-center">
            {{ respuesta }}
          </h3>
          <br />
          <ul style>
            <li v-for="error in errors" :key="error.name">{{ error }}</li>
          </ul>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" text @click="error = false">Corregir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Validación de datos-->
    <v-dialog v-model="advice" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">Alerta</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-md-center text-lg-center text-sm-center">
            ¿Esta seguro de dar de alta el Área?
          </h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="error" text @click="cancel()">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="guardar()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Confirmación de datos-->
    <v-dialog v-model="auxNivel" width="800">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">Jerarquía de niveles</span>
        </v-card-title>
        <v-card-text>
          <v-img src="../../../public/img/fondos/Level.svg" />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="auxNivel = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Confirmación de datos-->
    <v-dialog v-model="confirmation" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">Alta de Área</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-lg-center text-sm-center text-md-center">
            {{ respuesta }}
          </h3>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="aux()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import Loader from "@/components/Loader";
export default {
  components: {
    Sidebar,
    Loader,
  },
  data() {
    return {
      stepn: "4-N",
      error: false,
      show: false,
      errors: [],
      auxNivel: false,
      estructura: 0,
      structure: [
        {
          id: 1,
          nombre: "Empresa Comercial",
        },
        {
          id: 2,
          nombre: "Empresa Pagadora",
        },
      ],
      respuesta: "",
      titulo: "",
      nivel: 0,
      niveles: [
        {
          id: 1,
          nombre: "1",
        },
        {
          id: 2,
          nombre: "2",
        },
        {
          id: 3,
          nombre: "3",
        },
      ],
      carga: 0,
      cargas: [
        {
          id: 1,
          nombre: "Manual",
        },
        {
          id: 2,
          nombre: "Automatica",
        },
      ],
      pagadora: 0,
      pagadoras: [
        {
          id: 1,
          nombre: "Pagadora 1",
        },
        {
          id: 2,
          nombre: "Pagadora 2",
        },
      ],
      catalogo: true,
      lista: false,
      area: "",
      areas: [
        {
          id: 1,
          nombre: "area 1",
        },
        {
          id: 3,
          nombre: "area 3",
        },
      ],
      level: 0,
      levels: [
        {
          id: 1,
          nombre: "1",
        },
        {
          id: 3,
          nombre: "3",
        },
      ],
      nombreCorto: "",
      nombreArchivo: "",
      enterprise: 0,
      enterprises: [],
      advice: false,
      confirmation: false,
      selectedFile: "",
    };
  },
  methods: {
    nombre() {
      localStorage.stepn = this.stepn;
    },
    validacion() {
      this.errors = [];
      if (this.estructura == 0 || this.carga == 0) {
        this.errors.push(
          "Debe especificar la estructura organizacional y/o el tipo de carga"
        );
      }
      if (this.estructura == 2) {
        if (this.enterprise == 0 || this.enterprise == null)
          this.errors.push("Debe especificar la empresa pagadora.");
      }
      if (this.estructura == 2 && this.carga == 2) {
        if (!this.selectedFile)
          this.errors.push("Debes ingresar un archivo válido.");
      }
      if (this.errors.length == 0) {
        if (this.carga == 2) {
          if (this.estructura == 1)
            this.enterprise = localStorage.idCommercialEnterprise;
          this.procesarExcel();
        } else {
          this.catalogo = false;
          return (this.lista = true);
        }
      } else {
        this.titulo = "Catálogo de áreas";
        this.error = true;
      }
    },
    regresar() {
      this.lista = false;
      this.catalogo = true;
      this.enterprise = 0;
      this.area = "";
      this.nombreCorto = "";
      this.level = 0;
    },
    guardarArea() {
      console.log("level es " + this.level);
      this.errors = [];
      if (this.enterprise == 0) {
        this.errors.push("Se debe especificar la empresa.");
      }
      if (this.area == "" || this.area == " ") {
        this.errors.push("Se debe especificar el nombre de Área.");
      }
      if (this.nombreCorto == "" || this.nombreCorto == " ") {
        this.errors.push("Se debe especificar el nombre Corto del Área.");
      }
      if (this.level == 0) {
        this.errors.push("Se debe especificar el nivel de Área.");
      }
      if (this.errors.length == 0) {
        this.guardarAreaA();
      } else {
        this.titulo = "Agregar Área";
        return (this.error = true);
      }
    },
    guardarAreaA() {
      this.advice = false;
      this.show = true;
      axios
        .post(Server + "/areas", {
          NombreArea: this.area,
          NombreAreaCorto: this.nombreCorto,
          NivelJerarquico: parseInt(this.level),
          EmpresaId: this.enterprise,
        })
        .then((response) => {
          this.show = false;
          this.area = "";
          this.nombreCorto = "";
          this.enterprise = "";
          this.level = 0;
          this.respuesta = "El área fue guardada con éxito";
          this.confirmation = true;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
          this.area = "";
          this.nombreCorto = "";
          this.enterprise = "";
          this.level = 0;
          this.respuesta = "El área no fue almacenada";
          this.confirmation = true;
        });
    },
    previewFiles(event) {
      this.errors = [];
      console.log(event);
      this.nombreArchivo = event.target.files[0].name;
      this.nombreArchivo.toLowerCase();
      var regex = new RegExp("(.*?).(xlsx|xls)$");

      if (!regex.test(this.nombreArchivo)) {
        this.nombreArchivo = "";
        this.titulo = "Archivo inválido";
        this.errors.push(
          "No se permite el archivo que ingreso favor de ingresar archivo con layout predeterminado."
        );
        this.error = true;
      } else {
        this.selectedFile = event.target.files[0];
      }
    },

    listar() {
      this.show = true;
      axios
        .get(Server + "/empresas")
        .then((response) => {
          this.show = false;
          this.enterprises = response.data;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
        });
    },

    cancel() {
      this.area = "";
      this.nombreCorto = "";
      this.enterprise = "";
      this.level = 0;
      this.advice = false;
    },

    aux() {
      this.confirmation = false;
      this.area = "";
      this.nombreCorto = "";
      this.enterprise = "";
      this.level = 0;
      this.$router.push("/areasList");
    },

    resetFile() {
      this.$refs.fileUploadPerfilEdit.value = "";
    },

    procesarExcel: function () {
      var data = new FormData();
      data.append("idEmpresa", this.enterprise);
      data.append("excel", this.selectedFile, this.selectedFile.name);
      this.show = true;
      axios
        .post(Server + "/areas/cargar/excel", data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.show = false;
          this.respuesta = "Archivo procesado con éxito";
          this.confirmation = true;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
        });
    },

    descargaExcel() {
      this.show = true;
      ////console.log("Producto id");
      ////console.log(localStorage.productoId);
      axios(
        {
          url: Server + "/areas/plantilla",
          method: "GET",
          responseType: "blob",
        },
        { useCredentails: true }
      ) // CORS
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          var fecha = new Date();
          link.setAttribute("download", "Areas" + fecha.getTime() + ".xlsx");
          document.body.appendChild(link);
          link.click();
          this.show = false;
        })
        .catch((e) => {
          this.show = false;
        });
    },
  },
  created() {
    this.nombre();
    this.listar();
  },
};
</script>